import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'masterCpnFlags'
})
export class MasterCpnFlagsPipe implements PipeTransform {

  transform(value: string | number): string | number {
    switch (value) {
      case '1':
        return 'Yes';
      case 1:
        return 'Yes';
      case 'Y':
        return 'Yes';
      case '0':
        return 'No';
      case 0:
        return 'No';
      case 'N':
        return 'No';
      default:
        return value;
    }
  }

}
